import { Timezones,
         timesContainer,
         availableTimes,
         availableTimes2,
         calendarSelector,
         weeklyDateSelector,
         availabilityContainer,
         TimezoneSelectOptions,
         calendarSelectorFromDate }      from './templates/availability'
import { servicesList,
         serviceSetup,
         timeIntervals }                 from './templates/services'
import { resourcesList, 
         resourceSetup,
         resourceBlockedTimesList }      from './templates/resources'
import { searchForm,
         locationSetup,
         locationsList,
         businessHoursTable }            from './templates/locations'
import { errorBox,
         bookingForm,
         bookingFields,
         appointmentsList,
         appointmentSearchForm }         from './templates/appointments'
import { appointmentsModal }             from './templates/modals'
import { allocationsList, 
         allocationSetup,
         resourceAllocationSetup }       from './templates/allocations'
import { wizardTitle,
         wizardSteps, 
         wizardSections }                from './templates/wizards'
import { listImage,
         circleIcon,
         inputField,
         selectField,
         previewImage,
         confirmation,
         popupFormHeader,
         stateSelectOptions,
         getTimeSelectedAttr,
         initTimesSelectData,
         resourceGroupOptions,
         initTimesSelectOptions,
         countrySelectOptions,
         TimezoneOptions,
         TimezoneSearch,
         ProvinceSearch,
         ProvinceOptions,
         CountrySearch,
         CountryOptions,
         rescheduleConfirmation }       from './templates/miscellaneous'
import { CalendarTmpl,
         CalendarRescheduleConfirmationModalBody,
         CalendarAppointmentModalBody,
         CalendarToast,
         ServiceSelectedInfo,
         CalendarCancelModalBody,
         CalendarConfirmModalBody,
         CalendarRescheduleModalBody,
         CalendarCreateAppointmentModalBody,
         CalendarCreateAppointmentInitialModalBody,
         CalendarResources,
         CalendarBlockModalBody,
         CalendarPaginationBody,
         CalendarRemoveBlockModalBody } from './templates/calendar'


export const OnSchedTemplates = {
  // availability
  availabilityContainer,
  calendarSelectorFromDate,
  calendarSelector,
  availableTimes,
  availableTimes2,
  timesContainer,  
  Timezones,
  TimezoneSelectOptions,
  weeklyDateSelector, // unused - ask @JohnPaddon
  
  // services
  servicesList,
  serviceSetup,
  timeIntervals,

  // resources
  resourcesList,
  resourceSetup,
  resourceBlockedTimesList,

  // locations
  locationsList,
  locationSetup,
  searchForm,
  businessHoursTable,

  // appointments
  appointmentSearchForm,
  appointmentsList,
  bookingFields,
  bookingForm,
  errorBox,
  
  // modal
  appointmentsModal,
  
  // allocations
  allocationsList,
  allocationSetup,
  resourceAllocationSetup,
  
  // wizard
  wizardSteps,
  wizardSections,
  wizardTitle,
  
  // misc
  listImage,
  circleIcon,
  inputField,
  selectField,
  previewImage,
  confirmation,
  rescheduleConfirmation,
  popupFormHeader,
  stateSelectOptions,
  initTimesSelectData,
  getTimeSelectedAttr,
  resourceGroupOptions,
  countrySelectOptions,
  initTimesSelectOptions,
  TimezoneOptions,
  TimezoneSearch,
  ProvinceOptions,
  ProvinceSearch,
  CountryOptions,
  CountrySearch,

  // Calendar
  CalendarTmpl,
  CalendarRescheduleConfirmationModalBody,
  CalendarAppointmentModalBody,
  CalendarToast,
  ServiceSelectedInfo,
  CalendarCancelModalBody,
  CalendarConfirmModalBody,
  CalendarRescheduleModalBody,
  CalendarCreateAppointmentModalBody,
  CalendarCreateAppointmentInitialModalBody,
  CalendarResources,
  CalendarBlockModalBody,
  CalendarRemoveBlockModalBody,
  CalendarPaginationBody,
}
